import React from 'react';

import { useTranslations } from 'next-intl';

import { MenuSwitcher } from '../components';
import { DarkDisplayModeIcon, LightDisplayModeIcon } from '../icons';

import { KThemeMode } from './ThemeProvider';

interface IThemeModeSwitcherProps {
  mode: KThemeMode;
  compact?: boolean;
  className?: string;
  onChange(mode: KThemeMode): void;
}

export const ThemeModeSwitcher = ({
  mode,
  compact,
  onChange,
  className,
}: IThemeModeSwitcherProps) => {
  const t = useTranslations();

  return (
    <MenuSwitcher
      value={mode}
      compact={compact}
      className={className}
      options={[
        {
          icon: <LightDisplayModeIcon size="1000" />,
          iconPosition: 'start',
          label: t('THEME_MODE-LIGHT'),
          value: 'LIGHT',
        },
        {
          icon: <DarkDisplayModeIcon size="1000" />,
          iconPosition: 'start',
          label: t('THEME_MODE-DARK'),
          value: 'DARK',
        },
      ]}
      onChange={onChange}
    />
  );
};
